<template>
    <v-card v-if="pPriAlumno" max-width="600">
        <div class="d-flex flex-no-wrap bsp_header pt-2">
            <v-avatar class="ma-1" size="80" tile>
                <img src="@/assets/images/businessman.png" alt="Alumno">
            </v-avatar>
            <div>
                <v-card-title class="text-h5 pl-3 pt-1 pb-0">{{pPriAlumno.Alumno.split(',')[0].trim()}}</v-card-title>
                <v-card-title class="text-h5 pl-3 pt-0 pb-3">{{pPriAlumno.Alumno.split(',')[1].trim()}}
                    <v-icon size="15" @click="fuCopy(pPriAlumno.Alumno)" right dark>content_copy</v-icon>
                </v-card-title>                                
                <v-card-subtitle class="indigo--text text--darken-4">
                    <v-icon title="Nro de Documento de Identidad" color="#01579B">credit_card</v-icon>
                    <strong>{{pPriAlumno.DNI}}</strong>
                    <v-icon title="Celular" @click="fuMsj(pPriAlumno.Celular)" color="#01579B">phone_android</v-icon>
                    <strong>{{pPriAlumno.Celular}}</strong>
                    <v-icon title="Codigo" @click="fuCopy(pPriAlumno.IdAlumno)" color="#01579B">qr_code_2</v-icon>
                    <strong>{{pPriAlumno.Codigo}}</strong>
                </v-card-subtitle>
            </div>
        </div>
        <v-card-text class="py-0 px-0">
            <v-list two-line color="#2980b9" dark>
                <v-list-item class="px-0" style="height:10px">
                    <v-list-item-icon class='mr-1'><v-icon @click="fuCopy(pPriAlumno.IdServicio)">bookmark</v-icon></v-list-item-icon>
                    <v-list-item-content><span>{{pPriAlumno.priservicio.Iniciales}} - {{pPriAlumno.priservicio.Descripcion}}</span><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>
<script>
import {fuCopy} from '@/helpers/index.js';
export default {
    name: 'Matricula',
    props: {
        pPriAlumno: {
            type: Object,
            required: true,
        }
    },
    methods: {
        fuCopy,
        fuMsj(celular) {
            if (celular) {
                // Formatear el número (eliminar espacios o guiones si existen)
                const cleanNumber = celular.toString().replace(/\D/g, '');
                // Abrir WhatsApp Web o App
                window.open(`https://wa.me/51${cleanNumber}`, '_blank');
            }
        }
    },
}
</script>
<style scoped>
    .hover-scale {
        transform: scale(3);
        transition: transform 0.3s ease-in-out;
    }
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
</style>